import "./style.scss";
import $ from 'jquery';

$('.steps-block-slider').slick({
    asNavFor: '.steps-block-slider-nav',
    slidesToShow: 3,
    infinite: false,
    nextArrow: '<div class="next-ow"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M10 1.28003L17 8.28003L10 15.28M1 8.28003H17H1Z" stroke="#0C338C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' + '</svg></div>',
    prevArrow: '<div class="prev-ow"><svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n' + '<path d="M8 15.28L0.999999 8.28003L8 1.28003M17 8.28003L0.999999 8.28003L17 8.28003Z" stroke="#0C338C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' + '</svg></div>',
    responsive: [{
        breakpoint: 989, settings: {
            slidesToShow: 1, slidesToScroll: 1,
        }
    }]
});

$('.steps-block-slider-nav').slick({
    asNavFor: '.steps-block-slider',
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: false,
    arrows: false,
    focusOnSelect: true,
    // centerMode: true
});